import { useSearchParams } from 'react-router-dom';

type SetQueryParam = <T>(val: T) => void;

interface Params<T> {
  ifAbsent: T;
  provider: (val: string) => T;
}

const useQueryParam = <T>(
  key: string,
  { ifAbsent, provider }: Params<T>
): [T, SetQueryParam] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const value = searchParams.get(key);

  return [
    value !== null ? provider(value) : ifAbsent,
    (val) => {
      let next;
      if (val) {
        next = Object.assign(
          {},
          [...Array.from(searchParams.entries())].reduce(
            (o, [key, value]) => ({ ...o, [key]: value }),
            {}
          ),
          { [key]: String(val) }
        );
      } else {
        next = Object.assign(
          {},
          [...Array.from(searchParams.entries())].reduce(
            (o, [innerKey, value]) =>
              innerKey === key ? o : { ...o, [innerKey]: value },
            {}
          )
        );
      }
      setSearchParams(next);
    },
  ];
};

export default useQueryParam;
